import React, { Component } from "react";

import { withTranslation } from "react-i18next";
import {
  IconButton,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Tooltip from '@mui/material/Tooltip';
import { Help } from '@mui/icons-material';

export class DRXLayout extends Component {
  render() {
    const {
      t,
      classes,
      handleClickDRXKey,
      handleMouseDownDRXKey,
      showDRXKey,
      readOnly,
      drx_key,
      handleChangeDRXKey,
      handleChangeDRXHost,
      drx_host,
      drxHelpText
    } = this.props;
    return (
      <React.Fragment>
        <div style={{ display: "flex" }}>
          <FormControl
            className={classes.formControl}
            style={{ marginTop: "15px" }}
          >
            <InputLabel htmlFor="password" style={{ marginLeft: "-1rem" }}>
              {t("Accounts.Connect.DRX.DRXKkey")}
            </InputLabel>
            <Input
              className={classes.halfTextField}
              margin="normal"
              value={drx_key || ""}
              id="drx_key"
              name="drx_key"
              type={showDRXKey ? "text" : "password"}
              inputProps={{
                readOnly: Boolean(readOnly),
                name: 'random-name',
                autocomplete: 'new-password',
                form: {
                  autocomplete: 'off',
                },
              }}
              label="Password"
              placeholder=""
              onChange={handleChangeDRXKey}
              validators={["required"]}
              errorMessages={[t("Accounts.Connect.DRX.DRXKeyValidation")]}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickDRXKey}
                    onMouseDown={handleMouseDownDRXKey}
                  >
                    {showDRXKey ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl
            className={classes.formControl}
            style={{ marginTop: "15px" }}
          >
            <InputLabel style={{ marginLeft: "-1rem" }}>
              {t("Accounts.Connect.DRX.DRXHost")}
            </InputLabel>
            <Input
              className={classes.halfTextField}
              margin="normal"
              value={drx_host || ""}
              id="drx_host"
              name="drx_host"
              type={"text"}
              inputProps={{
                readOnly: Boolean(readOnly),
                name: 'random-name',
                autocomplete: 'new-password',
                form: {
                  autocomplete: 'off',
                },
              }}
              label="Password"
              placeholder=""
              onChange={handleChangeDRXHost}
              validators={["required"]}
              errorMessages={[t("Accounts.Connect.DRX.DRXHostValidation")]}
              endAdornment={
                <InputAdornment position='end'>
                  <Tooltip
                    title={drxHelpText}
                    className={classes.customWidth}>
                    <Help
                      className={classes.helpIcon}></Help>
                  </Tooltip>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>
      </React.Fragment>
    );
  }
}

export default (withTranslation()(DRXLayout));



// WEBPACK FOOTER //
// ./src/components/account-list/third-party/drx.js